import { type ThemeConfig } from '#imports'
import { defu } from 'defu'

/**
 * Convert keys with 'colorThemeFooterBackground' to 'some-css-var'
 * TODO: replace with function in formatString after Nuxt4 branch merge
 **/
function toKebabCase(object?: Record<string, string>) {
  if (!object) return object
  const result: Record<string, string> = {}
  for (const key in object) {
    const kebabKey = key.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()
    result[kebabKey] = object[key]
  }
  return result
}

export const useThemeConfig = () => {
  // Used as fallback
  const appConfig = useAppConfig()

  // Initially, set the theme config to the tenant theme config
  const { themeConfig: tenantThemeConfig } = useTenantConfig()

  // Prefer the tenant theme config over the app config, but use the app config as fallback
  function mergeWithDefaults(config: Partial<ThemeConfig>) {
    // Convert css vars tot kebab case (API serializer messes this up)
    config = { ...config, ...{ cssVariables: toKebabCase(config.cssVariables) } }

    return defu(config, appConfig.theme) as ThemeConfig
  }

  function setThemeConfig(config: Partial<ThemeConfig>) {
    themeConfig.value = mergeWithDefaults(config)
  }

  const themeConfig = useState<ThemeConfig>('themeConfig', () => mergeWithDefaults(tenantThemeConfig))

  return { themeConfig, setThemeConfig }
}
